import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import PhonePreview from "./TemplatePhonePreview";

export default function PreviewModal({
  open = false,
  onClose = () => {},
  onSubmit = () => {},
  summary = {},
  previewProps = {},
  loading = false,
}) {
  const categoryLabels = {
    marketing: "MARKETING",
    utility: "UTILITY",
    authentication: "AUTHENTICATION",
  };

  const {
    name = "Template name",
    category = "utility",
    language = "en",
    headerTypeLabel = "TEXT",
    templateBody = "",
    exampleBody = "",
  } = summary;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ pb: 1 }}>Vista previa</DialogTitle>

      <DialogContent dividers sx={{ pt: 2 }}>
        <Grid container spacing={3}>
          {/* Izquierda: resumen textual */}
          <Grid item xs={12} md={5}>
            <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
              <Typography variant="h6" sx={{ color: "primary.main", mb: 1 }}>
                {name}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1.5 }}>
                <strong>Categoría:</strong>{" "}
                {categoryLabels[category.toLowerCase()] || category}
              </Typography>

              <Typography variant="body2" sx={{ mb: 1.5 }}>
                <strong>Idioma:</strong> {language},{" "}
                <strong>Tipo:</strong>{" "}
                {category === "authentication" ? "TEXT" : headerTypeLabel}
              </Typography>

              <Box sx={{ mt: 1.5 }}>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  Plantilla:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "pre-wrap", pl: 1 }}
                >
                  {category === "authentication"
                    ? "{{1}} is your verification code."
                    : templateBody || "Cuerpo no definido"}
                </Typography>
              </Box>

              <Box sx={{ mt: 2 }}>
                <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                  Ejemplo:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ whiteSpace: "pre-wrap", pl: 1 }}
                >
                  {category === "authentication"
                    ? "123456 is your verification code."
                    : exampleBody || "Ejemplo no proporcionado."}
                </Typography>
              </Box>
            </Paper>
          </Grid>

          {/* Derecha: preview visual */}
          <Grid item xs={12} md={7}>
            <PhonePreview {...previewProps} />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ flexDirection: "column", alignItems: "stretch", gap: 1, px: 3, pb: 2 }}>
        {previewProps.submitError && (
          <Typography variant="body2" color="error" sx={{ textAlign: "center" }}>
            {previewProps.submitError}
          </Typography>
        )}
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
          <Button onClick={onClose} color="inherit">
            Cancelar
          </Button>
          <Button onClick={onSubmit} variant="contained" disabled={loading}>
            {loading ? <CircularProgress size={20} color="inherit" sx={{ mr: 1 }} /> : null}
            {loading ? "Enviando..." : "Enviar"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
